<template>
  <div class="payment-view">
    <section class="payment">
      <section class="payment-item billing-details" v-show="!this.clientHasCardOnFile">
        <div class="stripe-inline-container" :class="{'preloading submitting': stripeIsInitialising, 'submitting' : submittingPayment }">
          <fieldset>
            <legend>enter card details</legend>
            <div class="stripe-inline-container__form">
              <template v-if="stripe">
                  <div id="card-element"></div>
                  <p v-show="elementsError" id="card-errors" v-text="this.elementsError"></p>
                  <br >
                  <div class="actions" v-show="!this.paymentSuccess">
                    <button v-if="submittingPayment" class="button is-primary submit is-loading">Submitting payment</button>
                    <button v-else class="button is-primary submit" @click="makePayment()">Pay NZD {{ answers[getStep('Vehicle.Quote')].vehicle_quote_premium_raw | toCurrency }}</button>
                  </div>
              </template>

              <div class="columns  is-vcentered mt-1">
                <div class="column">
                  <div class="is-flex is-align-items-center">
                    <img class="icon-visa" src="/assets/images/visa_modern.png" />
                    <img class="icon-mastercard" src="/assets/images/policymastercard.jpg" />
                  </div>
                </div>
                <div class="column has-text-right is-hidden-mobile">
                  <svg id="stripe_logo_svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 34"><title>Powered by Stripe - blurple</title><path class="cls-1" d="M146,0H3.73A3.73,3.73,0,0,0,0,3.73V30.27A3.73,3.73,0,0,0,3.73,34H146a4,4,0,0,0,4-4V4A4,4,0,0,0,146,0Zm3,30a3,3,0,0,1-3,3H3.73A2.74,2.74,0,0,1,1,30.27V3.73A2.74,2.74,0,0,1,3.73,1H146a3,3,0,0,1,3,3Z"/><path class="cls-1" d="M17.07,11.24h-4.3V22h1.92V17.84h2.38c2.4,0,3.9-1.16,3.9-3.3S19.47,11.24,17.07,11.24Zm-.1,5H14.69v-3.3H17c1.38,0,2.11.59,2.11,1.65S18.35,16.19,17,16.19Z"/><path class="cls-1" d="M25.1,14a3.77,3.77,0,0,0-3.8,4.09,3.81,3.81,0,1,0,7.59,0A3.76,3.76,0,0,0,25.1,14Zm0,6.67c-1.22,0-2-1-2-2.58s.76-2.58,2-2.58,2,1,2,2.58S26.31,20.66,25.1,20.66Z"/><polygon class="cls-1" points="36.78 19.35 35.37 14.13 33.89 14.13 32.49 19.35 31.07 14.13 29.22 14.13 31.59 22.01 33.15 22.01 34.59 16.85 36.03 22.01 37.59 22.01 39.96 14.13 38.18 14.13 36.78 19.35"/><path class="cls-1" d="M44,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,47.49,20L46,19.38a1.78,1.78,0,0,1-1.83,1.26A2.12,2.12,0,0,1,42,18.47h5.52v-.6C47.54,15.71,46.32,14,44,14Zm-1.93,3.13A1.92,1.92,0,0,1,44,15.5a1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M50.69,15.3V14.13h-1.8V22h1.8V17.87a1.89,1.89,0,0,1,2-2,4.68,4.68,0,0,1,.66,0v-1.8c-.14,0-.3,0-.51,0A2.29,2.29,0,0,0,50.69,15.3Z"/><path class="cls-1" d="M57.48,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,60.93,20l-1.54-.59a1.78,1.78,0,0,1-1.83,1.26,2.12,2.12,0,0,1-2.1-2.17H61v-.6C61,15.71,59.76,14,57.48,14Zm-1.93,3.13a1.92,1.92,0,0,1,1.92-1.62,1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M67.56,15a2.85,2.85,0,0,0-2.26-1c-2.21,0-3.47,1.85-3.47,4.09s1.26,4.09,3.47,4.09a2.82,2.82,0,0,0,2.26-1V22h1.8V11.24h-1.8Zm0,3.35a2,2,0,0,1-2,2.28c-1.31,0-2-1-2-2.52s.7-2.52,2-2.52c1.11,0,2,.81,2,2.29Z"/><path class="cls-1" d="M79.31,14A2.88,2.88,0,0,0,77,15V11.24h-1.8V22H77v-.83a2.86,2.86,0,0,0,2.27,1c2.2,0,3.46-1.86,3.46-4.09S81.51,14,79.31,14ZM79,20.6a2,2,0,0,1-2-2.28v-.47c0-1.48.84-2.29,2-2.29,1.3,0,2,1,2,2.52S80.25,20.6,79,20.6Z"/><path class="cls-1" d="M86.93,19.66,85,14.13H83.1L86,21.72l-.3.74a1,1,0,0,1-1.14.79,4.12,4.12,0,0,1-.6,0v1.51a4.62,4.62,0,0,0,.73.05,2.67,2.67,0,0,0,2.78-2l3.24-8.62H88.82Z"/><path class="cls-1" d="M125,12.43a3,3,0,0,0-2.13.87l-.14-.69h-2.39V25.53l2.72-.59V21.81a3,3,0,0,0,1.93.7c1.94,0,3.72-1.59,3.72-5.11C128.71,14.18,126.91,12.43,125,12.43Zm-.65,7.63a1.61,1.61,0,0,1-1.28-.52l0-4.11a1.64,1.64,0,0,1,1.3-.55c1,0,1.68,1.13,1.68,2.58S125.36,20.06,124.35,20.06Z"/><path class="cls-1" d="M133.73,12.43c-2.62,0-4.21,2.26-4.21,5.11,0,3.37,1.88,5.08,4.56,5.08a6.12,6.12,0,0,0,3-.73V19.64a5.79,5.79,0,0,1-2.7.62c-1.08,0-2-.39-2.14-1.7h5.38c0-.15,0-.74,0-1C137.71,14.69,136.35,12.43,133.73,12.43Zm-1.47,4.07c0-1.26.77-1.79,1.45-1.79s1.4.53,1.4,1.79Z"/><path class="cls-1" d="M113,13.36l-.17-.82h-2.32v9.71h2.68V15.67a1.87,1.87,0,0,1,2.05-.58V12.54A1.8,1.8,0,0,0,113,13.36Z"/><path class="cls-1" d="M99.46,15.46c0-.44.36-.61.93-.61a5.9,5.9,0,0,1,2.7.72V12.94a7,7,0,0,0-2.7-.51c-2.21,0-3.68,1.18-3.68,3.16,0,3.1,4.14,2.6,4.14,3.93,0,.52-.44.69-1,.69a6.78,6.78,0,0,1-3-.9V22a7.38,7.38,0,0,0,3,.64c2.26,0,3.82-1.15,3.82-3.16C103.62,16.12,99.46,16.72,99.46,15.46Z"/><path class="cls-1" d="M107.28,10.24l-2.65.58v8.93a2.77,2.77,0,0,0,2.82,2.87,4.16,4.16,0,0,0,1.91-.37V20c-.35.15-2.06.66-2.06-1V15h2.06V12.66h-2.06Z"/><polygon class="cls-1" points="116.25 11.7 118.98 11.13 118.98 8.97 116.25 9.54 116.25 11.7"/><rect class="cls-1" x="116.25" y="12.61" width="2.73" height="9.64"/></svg>
                </div>
              </div>

            </div>

            <!-- Elements to add facy loading stuff to stirpe -->
            <div class="stripe-inline-container__loading"></div>
            <div class="stripe-inline-container__success">
              <div class="loader-icon">
                <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4" stroke="#000" fill="none"></circle>
                  <path class="checkmark" stroke-linecap="round" stroke-linejoin="round" d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338" stroke-width="4" stroke="#000" fill="none"></path>
                </svg>
              </div>
            </div>

          </fieldset>
        </div>
      </section>
      <!--      Pay from card on file   -->
      <div v-if="isAltFlow" class="columns">
        <div class="column">
          <strong><InlineText
              v-if="getAmountToPay > 0"
              label="Payment required"
              tooltip="This is the total additional premium to pay for the change to your policy."
              />
            <InlineText
                v-if="getAmountToPay <= 0"
                label="Refund"
                tooltip="We will refund this back onto your credit card or bank account."
              /></strong>
          <p v-if="getAmountToPay >= 0">NZD {{ getAmountToPay|toCurrency }}</p>
          <p v-else>NZD {{ (getAmountToPay*-1)|toCurrency }}</p>
        </div>
        <div class="column has-text-right is-hidden-mobile">
          <svg id="stripe_logo_svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 34"><title>Powered by Stripe - blurple</title><path class="cls-1" d="M146,0H3.73A3.73,3.73,0,0,0,0,3.73V30.27A3.73,3.73,0,0,0,3.73,34H146a4,4,0,0,0,4-4V4A4,4,0,0,0,146,0Zm3,30a3,3,0,0,1-3,3H3.73A2.74,2.74,0,0,1,1,30.27V3.73A2.74,2.74,0,0,1,3.73,1H146a3,3,0,0,1,3,3Z"/><path class="cls-1" d="M17.07,11.24h-4.3V22h1.92V17.84h2.38c2.4,0,3.9-1.16,3.9-3.3S19.47,11.24,17.07,11.24Zm-.1,5H14.69v-3.3H17c1.38,0,2.11.59,2.11,1.65S18.35,16.19,17,16.19Z"/><path class="cls-1" d="M25.1,14a3.77,3.77,0,0,0-3.8,4.09,3.81,3.81,0,1,0,7.59,0A3.76,3.76,0,0,0,25.1,14Zm0,6.67c-1.22,0-2-1-2-2.58s.76-2.58,2-2.58,2,1,2,2.58S26.31,20.66,25.1,20.66Z"/><polygon class="cls-1" points="36.78 19.35 35.37 14.13 33.89 14.13 32.49 19.35 31.07 14.13 29.22 14.13 31.59 22.01 33.15 22.01 34.59 16.85 36.03 22.01 37.59 22.01 39.96 14.13 38.18 14.13 36.78 19.35"/><path class="cls-1" d="M44,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,47.49,20L46,19.38a1.78,1.78,0,0,1-1.83,1.26A2.12,2.12,0,0,1,42,18.47h5.52v-.6C47.54,15.71,46.32,14,44,14Zm-1.93,3.13A1.92,1.92,0,0,1,44,15.5a1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M50.69,15.3V14.13h-1.8V22h1.8V17.87a1.89,1.89,0,0,1,2-2,4.68,4.68,0,0,1,.66,0v-1.8c-.14,0-.3,0-.51,0A2.29,2.29,0,0,0,50.69,15.3Z"/><path class="cls-1" d="M57.48,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,60.93,20l-1.54-.59a1.78,1.78,0,0,1-1.83,1.26,2.12,2.12,0,0,1-2.1-2.17H61v-.6C61,15.71,59.76,14,57.48,14Zm-1.93,3.13a1.92,1.92,0,0,1,1.92-1.62,1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M67.56,15a2.85,2.85,0,0,0-2.26-1c-2.21,0-3.47,1.85-3.47,4.09s1.26,4.09,3.47,4.09a2.82,2.82,0,0,0,2.26-1V22h1.8V11.24h-1.8Zm0,3.35a2,2,0,0,1-2,2.28c-1.31,0-2-1-2-2.52s.7-2.52,2-2.52c1.11,0,2,.81,2,2.29Z"/><path class="cls-1" d="M79.31,14A2.88,2.88,0,0,0,77,15V11.24h-1.8V22H77v-.83a2.86,2.86,0,0,0,2.27,1c2.2,0,3.46-1.86,3.46-4.09S81.51,14,79.31,14ZM79,20.6a2,2,0,0,1-2-2.28v-.47c0-1.48.84-2.29,2-2.29,1.3,0,2,1,2,2.52S80.25,20.6,79,20.6Z"/><path class="cls-1" d="M86.93,19.66,85,14.13H83.1L86,21.72l-.3.74a1,1,0,0,1-1.14.79,4.12,4.12,0,0,1-.6,0v1.51a4.62,4.62,0,0,0,.73.05,2.67,2.67,0,0,0,2.78-2l3.24-8.62H88.82Z"/><path class="cls-1" d="M125,12.43a3,3,0,0,0-2.13.87l-.14-.69h-2.39V25.53l2.72-.59V21.81a3,3,0,0,0,1.93.7c1.94,0,3.72-1.59,3.72-5.11C128.71,14.18,126.91,12.43,125,12.43Zm-.65,7.63a1.61,1.61,0,0,1-1.28-.52l0-4.11a1.64,1.64,0,0,1,1.3-.55c1,0,1.68,1.13,1.68,2.58S125.36,20.06,124.35,20.06Z"/><path class="cls-1" d="M133.73,12.43c-2.62,0-4.21,2.26-4.21,5.11,0,3.37,1.88,5.08,4.56,5.08a6.12,6.12,0,0,0,3-.73V19.64a5.79,5.79,0,0,1-2.7.62c-1.08,0-2-.39-2.14-1.7h5.38c0-.15,0-.74,0-1C137.71,14.69,136.35,12.43,133.73,12.43Zm-1.47,4.07c0-1.26.77-1.79,1.45-1.79s1.4.53,1.4,1.79Z"/><path class="cls-1" d="M113,13.36l-.17-.82h-2.32v9.71h2.68V15.67a1.87,1.87,0,0,1,2.05-.58V12.54A1.8,1.8,0,0,0,113,13.36Z"/><path class="cls-1" d="M99.46,15.46c0-.44.36-.61.93-.61a5.9,5.9,0,0,1,2.7.72V12.94a7,7,0,0,0-2.7-.51c-2.21,0-3.68,1.18-3.68,3.16,0,3.1,4.14,2.6,4.14,3.93,0,.52-.44.69-1,.69a6.78,6.78,0,0,1-3-.9V22a7.38,7.38,0,0,0,3,.64c2.26,0,3.82-1.15,3.82-3.16C103.62,16.12,99.46,16.72,99.46,15.46Z"/><path class="cls-1" d="M107.28,10.24l-2.65.58v8.93a2.77,2.77,0,0,0,2.82,2.87,4.16,4.16,0,0,0,1.91-.37V20c-.35.15-2.06.66-2.06-1V15h2.06V12.66h-2.06Z"/><polygon class="cls-1" points="116.25 11.7 118.98 11.13 118.98 8.97 116.25 9.54 116.25 11.7"/><rect class="cls-1" x="116.25" y="12.61" width="2.73" height="9.64"/></svg>
        </div>
      </div>
      <section class="payment-item billing-details has-text-centered" v-if="this.clientHasCardOnFile && !this.paymentSuccess">
        <button v-if="submittingPayment" class="button is-primary submit is-loading">Submitting payment</button>

        <button v-else class="button button-large-cta submit" @click="makePayment()">

          <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0528 8.54404H13.4777L13.4741 5.67122C13.4722 2.54312 10.9299 -0.00163256 7.80623 7.85832e-07C4.68254 0.0018236 2.14306 2.54849 2.14376 5.67752L2.1474 8.55034H1.94449C0.869882 8.55125 -0.000907745 9.42353 7.10166e-07 10.5L0.00182053 19.0522C0.00273062 20.1286 0.873518 21.0009 1.94813 21L14.0555 20.9936C15.1301 20.9927 16.0009 20.1204 16 19.044L15.9982 10.4918C15.9991 9.41533 15.1274 8.54305 14.0528 8.54396L14.0528 8.54404ZM8.53333 15.1085L8.53424 17.5312L7.65252 17.5321L7.65162 15.1094C7.16755 14.9298 6.81996 14.4668 6.81996 13.919C6.81905 13.2153 7.38865 12.6439 8.09201 12.6439C8.79445 12.643 9.36496 13.2135 9.36496 13.9181C9.36405 14.465 9.01737 14.928 8.53331 15.1085L8.53333 15.1085ZM11.3905 8.54498L4.23587 8.54862L4.23223 5.6758C4.23132 3.69973 5.83549 2.092 7.80735 2.09107C9.78005 2.09015 11.385 3.69707 11.386 5.6723L11.3905 8.54498Z" fill="white"/>
          </svg> &nbsp;
          <template v-if="getAmountToPay > 0">Pay ${{ getAmountToPay }} with {{ client.billing.card_type  }} ...{{ client.billing.card_last_4}}</template>
          <template v-else >Refund {{ (getAmountToPay*-1)|toCurrency }} to {{ client.billing.card_type  }} ...{{ client.billing.card_last_4}}</template>

        </button>

        <div v-if="!isAltFlow"  class="has-text-right is-hidden-mobile">
          <svg id="stripe_logo_svg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 34"><title>Powered by Stripe - blurple</title><path class="cls-1" d="M146,0H3.73A3.73,3.73,0,0,0,0,3.73V30.27A3.73,3.73,0,0,0,3.73,34H146a4,4,0,0,0,4-4V4A4,4,0,0,0,146,0Zm3,30a3,3,0,0,1-3,3H3.73A2.74,2.74,0,0,1,1,30.27V3.73A2.74,2.74,0,0,1,3.73,1H146a3,3,0,0,1,3,3Z"/><path class="cls-1" d="M17.07,11.24h-4.3V22h1.92V17.84h2.38c2.4,0,3.9-1.16,3.9-3.3S19.47,11.24,17.07,11.24Zm-.1,5H14.69v-3.3H17c1.38,0,2.11.59,2.11,1.65S18.35,16.19,17,16.19Z"/><path class="cls-1" d="M25.1,14a3.77,3.77,0,0,0-3.8,4.09,3.81,3.81,0,1,0,7.59,0A3.76,3.76,0,0,0,25.1,14Zm0,6.67c-1.22,0-2-1-2-2.58s.76-2.58,2-2.58,2,1,2,2.58S26.31,20.66,25.1,20.66Z"/><polygon class="cls-1" points="36.78 19.35 35.37 14.13 33.89 14.13 32.49 19.35 31.07 14.13 29.22 14.13 31.59 22.01 33.15 22.01 34.59 16.85 36.03 22.01 37.59 22.01 39.96 14.13 38.18 14.13 36.78 19.35"/><path class="cls-1" d="M44,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,47.49,20L46,19.38a1.78,1.78,0,0,1-1.83,1.26A2.12,2.12,0,0,1,42,18.47h5.52v-.6C47.54,15.71,46.32,14,44,14Zm-1.93,3.13A1.92,1.92,0,0,1,44,15.5a1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M50.69,15.3V14.13h-1.8V22h1.8V17.87a1.89,1.89,0,0,1,2-2,4.68,4.68,0,0,1,.66,0v-1.8c-.14,0-.3,0-.51,0A2.29,2.29,0,0,0,50.69,15.3Z"/><path class="cls-1" d="M57.48,14a3.83,3.83,0,0,0-3.75,4.09,3.79,3.79,0,0,0,3.83,4.09A3.47,3.47,0,0,0,60.93,20l-1.54-.59a1.78,1.78,0,0,1-1.83,1.26,2.12,2.12,0,0,1-2.1-2.17H61v-.6C61,15.71,59.76,14,57.48,14Zm-1.93,3.13a1.92,1.92,0,0,1,1.92-1.62,1.56,1.56,0,0,1,1.69,1.62Z"/><path class="cls-1" d="M67.56,15a2.85,2.85,0,0,0-2.26-1c-2.21,0-3.47,1.85-3.47,4.09s1.26,4.09,3.47,4.09a2.82,2.82,0,0,0,2.26-1V22h1.8V11.24h-1.8Zm0,3.35a2,2,0,0,1-2,2.28c-1.31,0-2-1-2-2.52s.7-2.52,2-2.52c1.11,0,2,.81,2,2.29Z"/><path class="cls-1" d="M79.31,14A2.88,2.88,0,0,0,77,15V11.24h-1.8V22H77v-.83a2.86,2.86,0,0,0,2.27,1c2.2,0,3.46-1.86,3.46-4.09S81.51,14,79.31,14ZM79,20.6a2,2,0,0,1-2-2.28v-.47c0-1.48.84-2.29,2-2.29,1.3,0,2,1,2,2.52S80.25,20.6,79,20.6Z"/><path class="cls-1" d="M86.93,19.66,85,14.13H83.1L86,21.72l-.3.74a1,1,0,0,1-1.14.79,4.12,4.12,0,0,1-.6,0v1.51a4.62,4.62,0,0,0,.73.05,2.67,2.67,0,0,0,2.78-2l3.24-8.62H88.82Z"/><path class="cls-1" d="M125,12.43a3,3,0,0,0-2.13.87l-.14-.69h-2.39V25.53l2.72-.59V21.81a3,3,0,0,0,1.93.7c1.94,0,3.72-1.59,3.72-5.11C128.71,14.18,126.91,12.43,125,12.43Zm-.65,7.63a1.61,1.61,0,0,1-1.28-.52l0-4.11a1.64,1.64,0,0,1,1.3-.55c1,0,1.68,1.13,1.68,2.58S125.36,20.06,124.35,20.06Z"/><path class="cls-1" d="M133.73,12.43c-2.62,0-4.21,2.26-4.21,5.11,0,3.37,1.88,5.08,4.56,5.08a6.12,6.12,0,0,0,3-.73V19.64a5.79,5.79,0,0,1-2.7.62c-1.08,0-2-.39-2.14-1.7h5.38c0-.15,0-.74,0-1C137.71,14.69,136.35,12.43,133.73,12.43Zm-1.47,4.07c0-1.26.77-1.79,1.45-1.79s1.4.53,1.4,1.79Z"/><path class="cls-1" d="M113,13.36l-.17-.82h-2.32v9.71h2.68V15.67a1.87,1.87,0,0,1,2.05-.58V12.54A1.8,1.8,0,0,0,113,13.36Z"/><path class="cls-1" d="M99.46,15.46c0-.44.36-.61.93-.61a5.9,5.9,0,0,1,2.7.72V12.94a7,7,0,0,0-2.7-.51c-2.21,0-3.68,1.18-3.68,3.16,0,3.1,4.14,2.6,4.14,3.93,0,.52-.44.69-1,.69a6.78,6.78,0,0,1-3-.9V22a7.38,7.38,0,0,0,3,.64c2.26,0,3.82-1.15,3.82-3.16C103.62,16.12,99.46,16.72,99.46,15.46Z"/><path class="cls-1" d="M107.28,10.24l-2.65.58v8.93a2.77,2.77,0,0,0,2.82,2.87,4.16,4.16,0,0,0,1.91-.37V20c-.35.15-2.06.66-2.06-1V15h2.06V12.66h-2.06Z"/><polygon class="cls-1" points="116.25 11.7 118.98 11.13 118.98 8.97 116.25 9.54 116.25 11.7"/><rect class="cls-1" x="116.25" y="12.61" width="2.73" height="9.64"/></svg>
        </div>

      </section>

    </section>
    <br />

    <section class="payment_errors notification is-warning mt-5" v-show="this.paymentErrors.length">
      <div :key="error" v-for="error in this.paymentErrors">
        {{ error }}
      </div>
    </section>
    <section class="notification is-success mt-5" v-show="this.paymentSuccess">
      Payment successful, confirming policy...
    </section>
  </div>
</template>

<script>
/**
 * Payment.vue
 * Stripe Billing demo. Created by Michael Glukhovsky (@mglukhovsky).
 *
 * Top-level component for choosing a payment method (with Stripe).
 */
import Vue from 'vue';
import axios from 'axios';
import { mapGetters } from 'vuex'
import store, { api } from '../../store/store.js';

export default {
  name: 'Payment',
  data() {
    return {
      card: null,
      elementsError: null,
      submittingPayment: false,
      stripeIsInitialising: false,
      paymentErrors: [],
      paymentSuccess: false,
    };
  },
  created() {


  },
  async mounted() {

    // Make sure we have stripe setup with the env key before continuing
    if (!this.$store.stripe) {
      await this.$store.dispatch('getStripeKey');
    }

    // Make sure we have got the initio clients billing details if they have any
    if (!this.$store.client) {
      // console.log('ajax client data if we dont have it',  this.$store.client);
      await this.$store.dispatch('getClientData');
    }

    // Reset the button loading state
    this.submittingPayment = false;

    // If they don't have an existing card on file, then setup the form to collect one to add
    if( ! this.clientHasCardOnFile ){

      // Create a Stripe Element if Stripe's library has been loaded
      if (this.stripe) {
        this.createElement();
      }
    }

  },
  beforeDestroy() {
    if (this.card) {
      this.card.unmount();
      this.card = null;
    }
  },
  computed: {
    clientHasCardOnFile: function(){
      if( this.client && this.client.billing && this.client.billing.card_type ){
        return true;
      } else {
        return false;
      }
    },
    getAmountToPay: function(){
      if( "vehicle_quote_adjustment_raw" in this.answers[this.getStep('Vehicle.Quote')] ){
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw;
      } else {
        return this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw;
      }
    },
    ...mapGetters({
      stripe: 'stripe',
      client: 'client',
      answers: 'flattenedAnswers',
      schemaHash: 'getSessionSchemaHash',
      getStep: 'getStep',
      isAltFlow: 'isAltFlow',
      isRenewFlow: 'isRenewFlow',
    }),
  },
  watch: {
    stripe: function (newStripe, oldStripe) {
      if (newStripe) {
          this.createElement();
      }
    }
  },
  methods: {
    createElement() {
      // console.log('createElement called', this.stripe);
      if (!this.stripe || this.clientHasCardOnFile) {
        // console.log('dont create stripe element, either no library loading or card on file');
        return;
      }

      this.stripeIsInitialising = true;

      const elements = this.stripe.elements({
        // Detect the locale automatically
        locale: 'auto',
      });
      // Define CSS styles for Elements
      const style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      };

      // Needs to be on the nextTick else the DOM element might not be ready yet.
      Vue.nextTick( () => {
        // Create the card element, then attach it to the DOM
        this.card = elements.create('card', {style});
        this.card.mount('#card-element');

        this.card.addEventListener('ready', (event) => {
          this.stripeIsInitialising = false;
        });


        // Add an event listener: check for error messages as we type
        this.card.addEventListener('change', ({error}) => {
          if (error) {
            this.elementsError = error.message;
          } else {
            this.elementsError = '';
          }
        });
      })

    },



    async submitPayment(params){
      try {
        let transaction_type = 'new';

        // Check if this is a renewal flow
        if (this.isRenewFlow) {
          transaction_type = 'renew';
        }
        // Check if this is an alteration flow
        else if( "vehicle_quote_adjustment_raw" in this.answers[this.getStep('Vehicle.Quote')] ){
          transaction_type = 'alt';
          params = { adjustment_amount: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_adjustment_raw, ...params};
        }

        return await axios.post(api.url + api.version + 'vehicle/' + transaction_type + '/make-stripe-payment/' + this.$store.state.session_id, {
          ...params,
          total_cost_inc_gst: this.answers[this.getStep('Vehicle.Quote')].vehicle_quote_premium_raw,
          schema_hash: this.schemaHash(),
        });
      } catch (err) {
        // Handle Error Here
        return err;
      }
    },

    async makePayment() {
      this.paymentErrors = []; // Reset the payment errors
      this.submittingPayment = true;

      // If card on file, then just process the new policy
      let client_facing_error = false;
      if( this.clientHasCardOnFile ){
        try {
          const submit_stripe_payment_resp = await this.submitPayment();

          // TODO go through standard panel submit...
          if( submit_stripe_payment_resp.data.results.success_data  ){
            this.submittingPayment = false;
            this.paymentSuccess = true;
            this.$emit('success-response-data', submit_stripe_payment_resp.data.results.success_data);
            return;
          } else if (submit_stripe_payment_resp.data.results.errors){
            client_facing_error = submit_stripe_payment_resp.data.results.errors.split("\n");
            console.log(client_facing_error);
            throw new Error('client-facing error'); // force the catch
          } else {
            throw new Error(''); // unknown error
          }
        } catch (err){
          // Always show the user a client-facing error.
          this.submittingPayment = false;
          // console.log('client_facing_error', client_facing_error);
          // Use error provided by backend.
          // Todo handle multiple error messages
          if( client_facing_error ){
            this.paymentErrors = client_facing_error;
          } else {
            // Likely the endpoint broke, backend won't be notified, provide generic error
            this.paymentErrors.push('No payment was made, there was a problem validating your session. Please try again.');
          }
          this.submittingPayment = false;
        }
        return;
      }


      // Handle a new card

      try {

        // Submit token
        const result = await this.stripe.createToken(this.card, { name: `${this.client.first_name} ${this.client.last_name}` });

        // console.warn('stripe result', result);

        if (result.error) {
          // Inform the customer that there was an error.
          this.elementsError = result.error.message;
          this.submittingPayment = false;
        } else {
          // Send the token to your server.
          const submit_stripe_payment_resp = await this.submitPayment({
            stripe_token: result.token.id,
            card_brand: result.token.card.brand,
          });

          if( submit_stripe_payment_resp.data.results.success_data  ) {
            this.submittingPayment = false;
            this.paymentSuccess = true;
            this.$emit('success-response-data', submit_stripe_payment_resp.data.results.success_data);
          } else {
            this.submittingPayment = false;
            if( submit_stripe_payment_resp.data.results.errors ) {
              this.paymentErrors.push(submit_stripe_payment_resp.data.results.errors);
            } else {
              this.paymentErrors.push("There was a problem"); // TODO - fix, gross
            }
          }
        }
        /*
          // Set id, brand, last4 in Store
          // this.$store.paymentMethod = {
          //   id: paymentMethod.id,
          //   brand: paymentMethod.card.brand,
          //   last4: paymentMethod.card.last4,
          // };
        */
      } catch (e) {
        this.paymentErrors.push(`there was a problem making your payment: ${e.message}`);
        this.submittingPayment = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
/*
stripe elements
https://github.com/stripe/elements-examples/blob/master/css/base.css / example 1
*/

#stripe_logo_svg {
  max-width: 150px;

  .cls-1{
    fill:#635bff;
  }
}

.icon-mastercard, .icon-visa {
  width: 60px;
  margin-right: 5px;
}

.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.stripe-inline-container button {
  border: none;
  border-radius: 4px;
  outline: none;
  text-decoration: none;
  color: #fff;
  background: #32325d;
  white-space: nowrap;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-decoration: none;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
}

.stripe-inline-container button:hover {
  transform: translateY(-1px);
  box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08);
  background-color: #43458b;
}

.stripe-inline-container__card-input {
  margin-bottom: 20px;
}

.stripe-inline-container.success .stripe-inline-container__form,
.stripe-inline-container.submitting .stripe-inline-container__form {
  opacity: 0;
  transform: scale(0.9);
  pointer-events: none;
}

.stripe-inline-container  #card-errors {
  color: red;
  padding: 5px;
}


.stripe-inline-container .group {
  background-color: white;
  height: 40px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
  margin-bottom: 20px;
}

.stripe-inline-container label {
  position: relative;
  color: #8898AA;
  height: 40px;
  line-height: 40px;
  /*margin-left: 20px;*/
  display: flex;
  flex-direction: row;
}

.stripe-inline-container .group label:not(:last-child) {
  border-bottom: 1px solid #F0F5FA;
}

.stripe-inline-container label > span {
  width: 120px;
  text-align: right;
  margin-right: 30px;
}

.stripe-inline-container .field {
  background: transparent;
  border: 0;
  outline: none;
  flex: 1;
  padding-right: 12px;
  padding-left: 12px;
  cursor: text;
  color: #32325d;
  line-height: 18px;
  font-family: "Helvetica Neue", Helvetica, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
}

.stripe-inline-container .field::-webkit-input-placeholder {
  color: #aab7c4;
}

.stripe-inline-container .field::-moz-placeholder {
  color: #aab7c4;
}

.stripe-inline-container fieldset {
  border: 1px solid #bec8d2;
  padding: 15px;
  border-radius: 6px;
}

.stripe-inline-container fieldset legend {
  margin: 0 auto;
  padding: 0 10px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: #32325d;
}

/* Stripe payment animations */

.stripe-inline-container  .stripe-inline-container__success {
  pointer-events: none;
  height:0;
  overflow: visible;
}

.stripe-inline-container.success .stripe-inline-container__success {
  pointer-events: all;
}

.stripe-inline-container.success  .stripe-inline-container__success .loader-icon .border,
.stripe-inline-container.success  .stripe-inline-container__success .loader-icon .checkmark {
  opacity: 1;
  stroke-dashoffset: 0 !important;
}



.stripe-inline-container .stripe-inline-container__success > * {
  transition-property: opacity, transform;
  transition-duration: 0.35s;
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  opacity: 0;
  transform: translateY(50px);
}

.stripe-inline-container.submitting.preloading  .stripe-inline-container__success .loader-icon {
  transform: translateY(-120px) scale(0.45);
  opacity: 0.5;
  text-align: center;
}

.stripe-inline-container.submitting  .stripe-inline-container__success .loader-icon,
.stripe-inline-container.success  .stripe-inline-container__success .loader-icon{
  opacity: 1;
}

.stripe-inline-container .stripe-inline-container__success .loader-icon {
  margin: 15px 0 30px;
  transform: translateY(-120px) scale(0.75);
  text-align: center;
}

.stripe-inline-container .stripe-inline-container__success .loader-icon svg {
  will-change: transform;
}

.stripe-inline-container .stripe-inline-container__success .loader-icon .border {
  stroke-dasharray: 251;
  stroke-dashoffset: 62.75;
  transform-origin: 50% 50%;
  transition: stroke-dashoffset 0.35s cubic-bezier(0.165, 0.84, 0.44, 1);
  animation: spin 1s linear infinite;
}

.stripe-inline-container .stripe-inline-container__success .loader-icon .checkmark {
  stroke-dasharray: 60;
  stroke-dashoffset: 60;
  transition: stroke-dashoffset 0.35s cubic-bezier(0.165, 0.84, 0.44, 1) 0.35s;
}


#stripe-token-handler {
  position: absolute;
  top: 0;
  left: 25%;
  right: 25%;
  padding: 20px 30px;
  border-radius: 0 0 4px 4px;
  box-sizing: border-box;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
  0 15px 35px rgba(50, 50, 93, 0.15),
  0 5px 15px rgba(0, 0, 0, 0.1);
  -webkit-transition: all 500ms ease-in-out;
  transition: all 500ms ease-in-out;
  transform: translateY(0);
  opacity: 1;
  background-color: white;
}

#stripe-token-handler.is-hidden {
  opacity: 0;
  transform: translateY(-80px);
}

/** Stripe animations styles */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(1turn);
  }
}

@keyframes void-animation-out {
  0%,
  to {
    opacity: 1;
  }
}
</style>